var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { fieldset, input, inputWrapper, innerWrapper, innerWrapperChecked, label, labelWidth } from '../styles/legacy';
import { fieldset as fieldsetCitron, input as inputCitron, inputChecked as inputCheckedCitron, inputWrapper as inputWrapperCitron, label as labelCitron, innerWrapper as innerWrapperCitron, innerWrapperChecked as innerWrapperCheckedCitron, styledInput as styledInputCitron, } from '../styles/citron';
import { cx, css as emotionCss } from 'emotion';
import { citrusStyled } from '@citrus/runtime';
import { isNotNullOrEmpty } from '@pcty/utils';
export var FieldSet = citrusStyled.div('fieldset', { legacy: fieldset, citrus2022: fieldsetCitron });
export var InputWrapper = citrusStyled.div('inputWrapper', {
    legacy: inputWrapper,
    citrus2022: inputWrapperCitron,
});
var XLabel = citrusStyled.label('label', { legacy: label, citrus2022: labelCitron });
export var TextWrapper = citrusStyled.div('N/A', null);
export var InnerWrapper = citrusStyled.div('innerWrapper', {
    legacy: innerWrapper,
    citrus2022: innerWrapperCitron,
});
export var InnerWrapperChecked = citrusStyled.div('innerWrapperChecked', {
    legacy: innerWrapperChecked,
    citrus2022: innerWrapperCheckedCitron,
});
export var Radio = citrusStyled.input('radio', { legacy: input, citrus2022: inputCitron });
export var RadioChecked = citrusStyled.input('radioChecked', { legacy: null, citrus2022: inputCheckedCitron });
export var StyledInput = citrusStyled.div('styledInput', { legacy: null, citrus2022: styledInputCitron });
export var Label = function (_a) {
    var _b;
    var children = _a.children, columns = _a.columns, className = _a.className, other = __rest(_a, ["children", "columns", "className"]);
    var emotionObj = (_b = {},
        _b[emotionCss(labelWidth(columns))] = isNotNullOrEmpty(columns),
        _b);
    var classes = cx(emotionObj, className || '');
    return (React.createElement(XLabel, __assign({ className: classes, styleNames: columns && ["col".concat(columns)] }, other), children));
};
export var Styled = {
    FieldSet: FieldSet,
    InputWrapper: InputWrapper,
    Label: Label,
    Radio: Radio,
    TextWrapper: TextWrapper,
    InnerWrapper: InnerWrapper,
    InnerWrapperChecked: InnerWrapperChecked,
};
